import { ArrowForwardIos, SvgIconComponent } from '@mui/icons-material';
import { FC } from 'react';
import { Button, ButtonProps } from '../button';
import { Tooltip } from '@mui/material';

export interface AlertBannerActionProps extends ButtonProps {
  ariaLabel?: string;
  actionIcon?: SvgIconComponent;
  tooltip?: string;
}

export const AlertBannerAction: FC<AlertBannerActionProps> = ({
  onClick,
  ariaLabel,
  actionIcon: ActionIcon = ArrowForwardIos,
  tooltip = '',
  color = 'inherit',
  ...props
}) => (
  <Tooltip title={tooltip}>
    <Button
      onClick={onClick}
      aria-label={ariaLabel || 'action'}
      size="small"
      variant="text"
      sx={{
        borderRadius: '50%',
        minWidth: 28,
        width: 28,
        height: 28,
        padding: 0,
        marginLeft: 0.5,
        color: color,
        boxShadow: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        '&:hover': { background: 'rgba(0,0,0,0.08)' },
        ...props.sx,
      }}
      {...props}
    >
      <ActionIcon style={{ fontSize: 16 }} />
    </Button>
  </Tooltip>
);
